import React from 'react';
import markFilledInput from "../../assets/markFilledInput.svg";
import styles from './styles.module.scss';

const MarkFileUploaded = () => {
  return (
    <img
      src={markFilledInput}
      alt="done"
      className={styles.fileUploaded}
    />
  )
};

export default MarkFileUploaded;
